var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list-view"},[_c('h1',[_vm._v(" Список пользователей ")]),_c('manager-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }